<script lang="ts" setup>
import Button from "primevue/button"
import Popover from "primevue/popover"
import { useTemplateRef } from "vue";

const popover = useTemplateRef('po')
const props = defineProps<{
  label?: string
  icon?: string
  severity?: string
  rounded?: boolean
  text?: boolean
  size?: "small" | "medium" | "large"
  variant?: string
}>()

</script>

<template>
  <Button :label="props.label" :icon="props.icon" @click="popover?.toggle" :variant="props.variant" :severity="severity"
    :size="size" :rounded="rounded" :text="text" />
  <Popover ref="po" class="w-70">
    <slot name="content"></slot>
  </Popover>
</template>
